import {
  ActionLogsViewColumns,
  actionLogsSearchSchema,
  mapActionLogsViewQuery,
} from "./ActionLogsView.default";
import ManagedGridView from "../controls/ManagedGridView";
import { SearchQuery } from "../code/search-query/search-query";
import { getActionLogs } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";

export interface ActionLogsViewProps {
  readonly trigger?: string;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
  /**
   * Scope every row to one person — set when an operator arrives from a user profile's **View Logs**.
   * PD-01 §4.3 lists "view logs" among the actions on a user; the capability was always here, it just had
   * no route from the person it is about.
   */
  readonly userUid?: string;
}

function ActionLogsView(props: ActionLogsViewProps) {
  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={ActionLogsViewColumns}
      schema={actionLogsSearchSchema}
      mapQuery={mapActionLogsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getActionLogs, { retry: true })}
      pageSize={100}
      // The filter panel already had a `userUid` textbox, so arriving pre-filtered needs no new control —
      // the value simply lands in the field the operator could have typed into, where they can see it and
      // change it. `autoSearch` runs the query on mount so the drill lands on rows, not an empty grid.
      initialValues={props.userUid ? { userUid: props.userUid } : undefined}
      autoSearch={!!props.userUid}
    />
  );
}

export default ActionLogsView;
